/*

In this file are all hex values for all 6 parent colors and their 21 point scale.
These are all the colors to be used on applyboard.com as per the new UI design.

WHITE is exported for convenience so it can be used as a variable like the other colors.

0 - Darkest
21 - Lightest

No Javascript/Typescript file should have a hardcoded color value. 

*/

export var WHITE = '#FFFFFF';
export var BLUE = {
  1: '#000F33',
  2: '#001745',
  3: '#00215C',
  4: '#002B72',
  5: '#003384',
  6: '#003B98',
  7: '#0044AB',
  8: '#004DC0',
  9: '#0056D5',
  10: '#0064E1',
  11: '#0072EE',
  12: '#0081FC',
  13: '#3590FF',
  14: '#579FFF',
  15: '#75AFFF',
  16: '#8EBEFF',
  17: '#A6CCFF',
  18: '#BED9FF',
  19: '#D0E4FF',
  20: '#DFECFF',
  21: '#F1F7FF'
};
export var GREEN = {
  1: '#001507',
  2: '#001F0C',
  3: '#002C14',
  4: '#00361A',
  5: '#004120',
  6: '#004D27',
  7: '#00572D',
  8: '#006233',
  9: '#006D3A',
  10: '#007A42',
  11: '#148750',
  12: '#259360',
  13: '#36A271',
  14: '#46B082',
  15: '#58BE91',
  16: '#69CD9F',
  17: '#7BDCAE',
  18: '#8AE8BB',
  19: '#95F4C6',
  20: '#BDF7D9',
  21: '#E4FBEE'
};
export var AMBER = {
  1: '#200C00',
  2: '#2C1400',
  3: '#3C1D00',
  4: '#4A2500',
  5: '#592D00',
  6: '#663500',
  7: '#743D00',
  8: '#824500',
  9: '#914E00',
  10: '#A15700',
  11: '#AE6400',
  12: '#BC7100',
  13: '#CA7F00',
  14: '#D88E00',
  15: '#E39F24',
  16: '#EDB03B',
  17: '#F7C14E',
  18: '#FAD08A',
  19: '#FBDDB1',
  20: '#FCE8CE',
  21: '#FEF5EA'
};
export var RED = {
  1: '#2E0004',
  2: '#3D0008',
  3: '#52000E',
  4: '#650013',
  5: '#770018',
  6: '#88001D',
  7: '#9B0022',
  8: '#AC0228',
  9: '#BE0E31',
  10: '#CF1A3A',
  11: '#E32645',
  12: '#F23953',
  13: '#F35C6C',
  14: '#F47782',
  15: '#F58F97',
  16: '#F6A5AB',
  17: '#F8B9BD',
  18: '#F9CBCE',
  19: '#FBD9DB',
  20: '#FCE6E7',
  21: '#FEF4F5'
};
export var VIOLET = {
  1: '#260222',
  2: '#35032F',
  3: '#470640',
  4: '#580950',
  5: '#680C5F',
  6: '#77106C',
  7: '#85167A',
  8: '#932287',
  9: '#9F2E94',
  10: '#AD3AA1',
  11: '#B948AE',
  12: '#C756BB',
  13: '#D367C8',
  14: '#D87ECE',
  15: '#DE93D5',
  16: '#E4A7DC',
  17: '#E9BBE3',
  18: '#EECBEA',
  19: '#F3DAEF',
  20: '#F7E6F5',
  21: '#FBF4FA'
};
export var GRAY = {
  1: '#0E1118',
  2: '#161A22',
  3: '#202530',
  4: '#2A2F3C',
  5: '#323847',
  6: '#3B4153',
  7: '#434A5E',
  8: '#4C556A',
  9: '#565F76',
  10: '#606A84',
  11: '#6B7592',
  12: '#7682A1',
  13: '#848FAE',
  14: '#949DB8',
  15: '#A4ACC2',
  16: '#B4BACD',
  17: '#C4C9D7',
  18: '#D2D6E1',
  19: '#DEE1E9',
  20: '#E9EBF0',
  21: '#F5F6F8'
};